import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Result} from "@domain/common/http/result";
import {ParamOmp} from "@domain/admin/parametre/formulaire/param-omp";
import {ParamOm} from "@domain/admin/parametre/formulaire/param-om";
import {ParamNdf} from "@domain/admin/parametre/formulaire/param-ndf";
import {ParamAvance} from "@domain/admin/parametre/formulaire/param-avance";
import {ParamDossierVoyage} from "@domain/admin/parametre/formulaire/param-dossier-voyage";
import {ParamFacture} from "@domain/admin/parametre/formulaire/param-facture";

/**
 * Service des appels des formulaires
 *
 * @author Lionel Gimenez
 * @date 04/09/2025
 */
@Injectable({
    providedIn: "root",
})
export class FormulaireHttpService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Chargement des paramètres des OMP
     */
    loadOmp(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadOMPermanentParam`,null);
    }

    /**
     * Sauvegarde les paramètres des OMP
     */
    saveOmp(paramOMP: ParamOmp): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveOMPermanentParam`,paramOMP);
    }

    /**
     * Chargement des paramètres des OM
     */
    loadOm(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadOMParam`,null);
    }

    /**
     * Sauvegarde les paramètres des OM
     */
    saveOm(paramOM: ParamOm): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveOMParam`,paramOM);
    }

    /**
     * Chargement des paramètres du formulaire voyage
     */
    loadFormulaireVoyage(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadDossierVoyageParam`,null);
    }

    /**
     * Sauvegarde les paramètres du formulaire voyage
     */
    saveFormulaireVoyage(paramDossierVoyage: ParamDossierVoyage): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveDossierVoyageParam`,paramDossierVoyage);
    }

    /**
     * Chargement des paramètres NDF
     */
    getParamNdf(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadNdfParam`,null);
    }

    /**
     * Sauvegarde les paramètres NDF
     */
    saveParamNdf(paramNdf: ParamNdf): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveNDFParam`,paramNdf);
    }

    /**
     * Chargement des paramètres Facture
     */
    getParamFacture(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadFactureParam`,null);
    }

    /**
     * Sauvegarde les paramètres Facture
     */
    saveParamFacture(paramFacture: ParamFacture): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveFactureParam`,paramFacture);
    }

    /**
     * Chargement des paramètres avance
     */
    getParamAvance(): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/loadAvanceParam`,null);
    }

    /**
     * Sauvegarde les paramètres avance
     */
    saveParamAvance(paramAvance: ParamAvance): Observable<Result> {
        return this.http.post<Result>(`/controller/Portee/saveAvanceParam`,paramAvance);
    }
}